module.exports = __webpack_public_path__ + "img/1.3af04b75.png";